import { IDataValidation } from './IDataValidationSerivice';
import { DataValidation } from './dataValidationService';

export class DataValidationServiceBuilder {
    public static Instance(): IDataValidation {
        return new DataValidation();
    }
}
